<template>
  <section class="account-page">
    <b-container class="py-4">
      <h1 class="mb-2">My Account</h1>
      <p class="text-muted mb-4">
        Your essays and feedback history live here.
      </p>

      <b-card>
        <p class="mb-1"><strong>Email:</strong> {{ userEmail }}</p>
        <p class="mb-1"><strong>Name:</strong> {{ displayName || "Not set" }}</p>
        <p class="mb-1"><strong>Plan:</strong> {{ planLabel }}</p>
        <p class="mb-1"><strong>Feedback access:</strong> {{ feedbackStatusMessage }}</p>
        <p v-if="!isProUser" class="mb-3 text-muted">
          {{ feedbackCount }} of {{ freeFeedbackLimit }} free submissions used.
        </p>
        <p v-else class="mb-3 text-muted">
          Pro access is enabled on this account.
        </p>

        <div class="d-flex gap-2 flex-wrap">
          <b-button variant="outline-primary" @click="goToFeedbackHistory">
            My Essays
          </b-button>
        </div>
      </b-card>
    </b-container>
  </section>
</template>

<script>
import { computed } from "vue";
import { useRouter } from "vue-router";
import { useSubscriptionAccess } from "@/composables/useSubscriptionAccess";

export default {
  name: "AccountView",
  setup() {
    const router = useRouter();
    const {
      user,
      normalizedProfile,
      isProUser,
      feedbackStatusMessage
    } = useSubscriptionAccess();

    const userEmail = computed(() => user.value?.email || "-");
    const displayName = computed(
      () => normalizedProfile.value?.displayName || user.value?.displayName || ""
    );
    const planLabel = computed(() =>
      normalizedProfile.value.plan === "pro" ? "Pro" : "Free"
    );
    const feedbackCount = computed(() => normalizedProfile.value.feedbackCount || 0);
    const freeFeedbackLimit = computed(
      () => normalizedProfile.value.freeFeedbackLimit || 0
    );

    const goToFeedbackHistory = () => router.push({ name: "FeedbackHistory" });

    return {
      userEmail,
      displayName,
      planLabel,
      feedbackCount,
      freeFeedbackLimit,
      feedbackStatusMessage,
      isProUser,
      goToFeedbackHistory,
    };
  }
};
</script>

<style scoped>
.account-page {
  min-height: 70vh;
}
</style>
